import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { Rate } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import NoImage from "../../../images/no-image.jpg"; // replace with your placeholder image
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getCountries } from "../../../services/CountryService";
import Swal from "sweetalert2";
import PageTitle from "../../layouts/PageTitle";
import { Button } from "react-bootstrap";
import CkEditorBlog from "../Forms/CkEditor/CkEditorBlog";
import { getCurrency } from "../../../services/CurrencyService";
import { getDegree } from "../../../services/DegreeService";
import { getCourseType } from "../../../services/CourseTypeService";
import { getUniversity } from "../../../services/UniversityService";
import { getApplication } from "../../../services/ApplicationService";
import { getDuration } from "../../../services/DurationService";
import { getLanguage } from "../../../services/LanguageService";
import { getSubject } from "../../../services/SubjectService";
import {
  addStudyProgram,
  getStudyProgramById,
  updateStudyProgram,
} from "../../../services/StudyProgramService";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import CustomClassicEditor from "../CustomClassicEditor";

const statusOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const multiSelectComponents = {
  MultiValue: ({ data, removeProps }) => (
    <div
      className="d-flex align-items-center"
      style={{
        background: "#EEF2FF",
        borderRadius: "16px",
        padding: "2px 8px",
        margin: "2px",
        maxWidth: "180px",
      }}
    >
      <span
        style={{
          fontSize: "12px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {data.label}
      </span>

      <span
        {...removeProps}
        style={{
          marginLeft: "6px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        ×
      </span>
    </div>
  ),
};

const AddStudyProgram = () => {
  const [formData, setFormData] = useState({
    course_name: "",
    start_of_study: "",
    application_winter_period: "",
    application_winter_deadline: "",
    application_summer_period: "",
    application_summer_deadline: "",
    semester_contribution: "",
    course_credit: "",
    admission_restricted: null,
    admission_requirement: "",
    career_prospect: "",
    curriculum_structure: "",
    course_link: "",
    application_portal: "",
    degree_id: null,
    coursetype_id: null,
    university_id: null,
    application_id: null,
    subject_ids: null,
    language_ids: null,
    duration_ids: null,
    fees: "",
    tution_fees_per_semester: "",
    // currency_id: null,
    country_ids: null,
  });

  const [courseImage, setCourseImage] = useState(null);
  const [existingImage, setExistingImage] = useState("");
  const [errors, setErrors] = useState({});
  const hasFetched = useRef(false);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const isViewMode = location.pathname.startsWith("/view-study-program");

  // dropdown mock data
  const [degreeOptions, setDegreeOptions] = useState([]);
  const [degreePage, setDegreePage] = useState(1);
  const [degreeTotalPages, setDegreeTotalPages] = useState(1);
  const [degreeLoading, setDegreeLoading] = useState(false);

  const [courseTypeOptions, setCourseTypeOptions] = useState([]);
  const [courseTypePage, setCourseTypePage] = useState(1);
  const [courseTypeTotalPages, setCourseTypeTotalPages] = useState(1);
  const [courseTypeLoading, setCourseTypeLoading] = useState(false);

  const [universityOptions, setUniversityOptions] = useState([]);
  const [universityPage, setUniversityPage] = useState(1);
  const [universityTotalPages, setUniversityTotalPages] = useState(1);
  const [universityLoading, setUniversityLoading] = useState(false);

  const [applicationOptions, setApplicationOptions] = useState([]);
  const [applicationPage, setApplicationPage] = useState(1);
  const [applicationTotalPages, setApplicationTotalPages] = useState(1);
  const [applicationLoading, setApplicationLoading] = useState(false);

  const [subjectOptions, setSubjectOptions] = useState([]);
  const [subjectPage, setSubjectPage] = useState(1);
  const [subjectTotalPages, setSubjectTotalPages] = useState(1);
  const [subjectLoading, setSubjectLoading] = useState(false);

  const [languageOptions, setLanguageOptions] = useState([]);
  const [languagePage, setLanguagePage] = useState(1);
  const [languageTotalPages, setLanguageTotalPages] = useState(1);
  const [languageLoading, setLanguageLoading] = useState(false);

  const [durationOptions, setDurationOptions] = useState([]);
  const [durationPage, setDurationPage] = useState(1);
  const [durationTotalPages, setDurationTotalPages] = useState(1);
  const [durationLoading, setDurationLoading] = useState(false);

  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [currencyPage, setCurrencyPage] = useState(1);
  const [currencyTotalPages, setCurrencyTotalPages] = useState(1);
  const [currencyLoading, setCurrencyLoading] = useState(false);

  const [countryOptions, setCountryOptions] = useState([]);
  const [countryPage, setCountryPage] = useState(1);
  const [countryTotalPages, setCountryTotalPages] = useState(1);
  const [countryLoading, setCountryLoading] = useState(false);

  const fetchDegree = async (pageNumber = 1, limit = 5, query = "") => {
    if (pageNumber > degreeTotalPages) return; // no more pages
    try {
      setDegreeLoading(true);
      const response = await getDegree(pageNumber, limit, query);
      const { data, pagination } = response.data;

      const options = (data || []).map((c) => ({
        value: c.id,
        label: c.title,
      }));

      if (pageNumber === 1) {
        // first page or search => replace
        setDegreeOptions(options);
      } else {
        // append for scroll
        setDegreeOptions((prev) => [...prev, ...options]);
      }

      setDegreePage(pagination?.page || pageNumber);
      setDegreeTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching degrees:", error);
    } finally {
      setDegreeLoading(false);
    }
  };

  const fetchCourseType = async (pageNumber = 1, limit = 5, query = "") => {
    if (pageNumber > courseTypeTotalPages) return; // no more pages
    try {
      setCourseTypeLoading(true);
      const response = await getCourseType(pageNumber, limit, query);
      const { data, pagination } = response.data;

      const options = (data || []).map((c) => ({
        value: c.id,
        label: c.title,
      }));

      if (pageNumber === 1) {
        // first page or search => replace
        setCourseTypeOptions(options);
      } else {
        // append for scroll
        setCourseTypeOptions((prev) => [...prev, ...options]);
      }

      setCourseTypePage(pagination?.page || pageNumber);
      setCourseTypeTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching courseTypes:", error);
    } finally {
      setCourseTypeLoading(false);
    }
  };

  const fetchUniversity = async (pageNumber = 1, limit = 5, query = "") => {
    if (pageNumber > universityTotalPages) return; // no more pages
    try {
      setUniversityLoading(true);
      const response = await getUniversity(pageNumber, limit, query);
      const { data, pagination } = response.data;

      const options = (data || []).map((c) => ({
        value: c.id,
        label: c.title,
      }));

      if (pageNumber === 1) {
        // first page or search => replace
        setUniversityOptions(options);
      } else {
        // append for scroll
        setUniversityOptions((prev) => [...prev, ...options]);
      }

      setUniversityPage(pagination?.page || pageNumber);
      setUniversityTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching universities:", error);
    } finally {
      setUniversityLoading(false);
    }
  };

  const fetchApplication = async (pageNumber = 1, limit = 5, query = "") => {
    if (pageNumber > applicationTotalPages) return; // no more pages
    try {
      setApplicationLoading(true);
      const response = await getApplication(pageNumber, limit, query);
      const { data, pagination } = response.data;

      const options = (data || []).map((c) => ({
        value: c.id,
        label: c.title,
      }));

      if (pageNumber === 1) {
        // first page or search => replace
        setApplicationOptions(options);
      } else {
        // append for scroll
        setApplicationOptions((prev) => [...prev, ...options]);
      }

      setApplicationPage(pagination?.page || pageNumber);
      setApplicationTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching applications:", error);
    } finally {
      setApplicationLoading(false);
    }
  };

  const fetchSubject = async (pageNumber = 1, limit = 5, query = "") => {
    if (pageNumber > subjectTotalPages) return;
    try {
      setSubjectLoading(true);
      const response = await getSubject(pageNumber, limit, query);
      const { data, pagination } = response.data;
      const options = (data || []).map((c) => ({ value: c.id, label: c.name }));
      if (pageNumber === 1) {
        setSubjectOptions(options);
      } else {
        setSubjectOptions((prev) => [...prev, ...options]);
      }
      setSubjectPage(pagination?.page || pageNumber);
      setSubjectTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    } finally {
      setSubjectLoading(false);
    }
  };

  const fetchLanguage = async (pageNumber = 1, limit = 5, query = "") => {
    if (pageNumber > languageTotalPages) return;
    try {
      setLanguageLoading(true);
      const response = await getLanguage(pageNumber, limit, query);
      const { data, pagination } = response.data;
      const options = (data || []).map((c) => ({ value: c.id, label: c.name }));
      if (pageNumber === 1) {
        setLanguageOptions(options);
      } else {
        setLanguageOptions((prev) => [...prev, ...options]);
      }
      setLanguagePage(pagination?.page || pageNumber);
      setLanguageTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching languages:", error);
    } finally {
      setLanguageLoading(false);
    }
  };

  const fetchDuration = async (pageNumber = 1, limit = 5, query = "") => {
    if (pageNumber > durationTotalPages) return;
    try {
      setDurationLoading(true);
      const response = await getDuration(pageNumber, limit, query);
      const { data, pagination } = response.data;
      const options = (data || []).map((c) => ({
        value: c.id,
        label: c.title,
      }));
      if (pageNumber === 1) {
        setDurationOptions(options);
      } else {
        setDurationOptions((prev) => [...prev, ...options]);
      }
      setDurationPage(pagination?.page || pageNumber);
      setDurationTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching durations:", error);
    } finally {
      setDurationLoading(false);
    }
  };

  const fetchCurrency = async (pageNumber = 1, limit = 5, query = "") => {
    if (pageNumber > currencyTotalPages) return; // no more pages
    try {
      setCurrencyLoading(true);
      const response = await getCurrency(pageNumber, limit, query);
      const { data, pagination } = response.data;

      const options = (data || []).map((c) => ({
        value: c.id,
        label: `${c.currency_value} (${c.currency_symbol})`,
      }));

      if (pageNumber === 1) {
        // first page or search => replace
        setCurrencyOptions(options);
      } else {
        // append for scroll
        setCurrencyOptions((prev) => [...prev, ...options]);
      }

      setCurrencyPage(pagination?.page || pageNumber);
      setCurrencyTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching currencies:", error);
    } finally {
      setCurrencyLoading(false);
    }
  };

  const fetchCountry = async (pageNumber = 1, limit = 5, query = "") => {
    if (pageNumber > countryTotalPages) return; // no more pages
    try {
      setCountryLoading(true);
      const response = await getCountries(pageNumber, limit, query);
      const { data, pagination } = response.data;

      const options = (data || []).map((c) => ({ value: c.id, label: c.name }));

      if (pageNumber === 1) {
        // first page or search => replace
        setCountryOptions(options);
      } else {
        // append for scroll
        setCountryOptions((prev) => [...prev, ...options]);
      }

      setCountryPage(pagination?.page || pageNumber);
      setCountryTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleFileChange = (e) => {
    setCourseImage(e.target.files[0]);
  };

  const handleCountryChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      country_ids: selectedOption,
    }));
  };

  const handleDurationChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      duration_ids: selectedOption,
    }));
  };

  const handleLanguageChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      language_ids: selectedOption,
    }));
  };

  const handleSubjectChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      subject_ids: selectedOption,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.course_name.trim())
      newErrors.course_name = "Course Name is required";
    if (!formData.application_id)
      newErrors.application_id = "Application is required";
    if (!formData.duration_ids) newErrors.duration_ids = "Duration is required";
    if (!formData.language_ids) newErrors.language_ids = "Language is required";
    if (!formData.subject_ids) newErrors.subject_ids = "Subject is required";
    if (!formData.country_ids) newErrors.country_ids = "Country is required";

    return newErrors;
  };

  const cleanEditorContent = (html = "") => {
    if (!html) return "";

    let cleaned = html.trim();

    // loop because last may be [empty_line] + <p>&nbsp;</p> + [empty_line]
    let changed = true;

    while (changed) {
      changed = false;

      // remove only one trailing empty paragraph block
      const removedParagraph = cleaned.replace(
        /<p>(?:&nbsp;|\s|<br\s*\/?>)*<\/p>\s*$/i,
        ""
      );

      if (removedParagraph !== cleaned) {
        cleaned = removedParagraph.trim();
        changed = true;
      }

      // remove only one trailing [empty_line]
      const removedToken = cleaned.replace(
        /\[empty_line\]\s*$/i,
        ""
      );

      if (removedToken !== cleaned) {
        cleaned = removedToken.trim();
        changed = true;
      }
    }

    return cleaned;
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const [
          degreeRes,
          universityRes,
          applicationRes,
          subjectRes,
          languageRes,
          durationRes,
          // currencyRes,
          countryRes,
          courseTypeRes,
        ] = await Promise.all([
          getDegree(1, 5000), // fetch all or enough for dropdown
          getUniversity(1, 5000),
          getApplication(1, 5000),
          getSubject(1, 5000),
          getLanguage(1, 5000),
          getDuration(1, 5000),
          getCountries(1, 5000),
          getCourseType(1, 5000), // to map degree_id to degree title in edit mode
        ]);

        const degreeOpts = (degreeRes.data?.data || []).map((c) => ({
          value: c.id,
          label: c.title,
        }));
        setDegreeOptions(degreeOpts);

        const courseTypeOpts = (courseTypeRes.data?.data || []).map((c) => ({
          value: c.id,
          label: c.title,
        }));
        setCourseTypeOptions(courseTypeOpts);

        const universityOpts = (universityRes.data?.data || []).map((c) => ({
          value: c.id,
          label: c.title,
        }));
        setUniversityOptions(universityOpts);

        const applicationOpts = (applicationRes.data?.data || []).map((c) => ({
          value: c.id,
          label: c.title,
        }));
        setApplicationOptions(applicationOpts);

        const subjectOpts = (subjectRes.data?.data || []).map((c) => ({
          value: c.id,
          label: c.name,
        }));
        setSubjectOptions(subjectOpts);

        const languageOpts = (languageRes.data?.data || []).map((c) => ({
          value: c.id,
          label: c.name,
        }));
        setLanguageOptions(languageOpts);

        const durationOpts = (durationRes.data?.data || []).map((c) => ({
          value: c.id,
          label: c.title,
        }));
        setDurationOptions(durationOpts);

        const countryOpts = (countryRes.data?.data || []).map((c) => ({
          value: c.id,
          label: c.name,
        }));
        setCountryOptions(countryOpts);
        // 2️⃣ Then fetch blog by ID
        if (id) {
          const res = await getStudyProgramById(id);
          if (res.data?.success) {
            const studyProgram = res.data.data;

            const selectedCountries =
              (studyProgram.country_ids || [])
                .map((id) => {
                  const country = countryOpts.find((c) => c.value === id);
                  return country
                    ? country
                    : { value: id, label: `Country ${id}` }; // fallback label
                })
                .filter(Boolean) || [];

            const selectedDurations =
              (studyProgram.duration_ids || [])
                .map((id) => {
                  const duration = durationOpts.find((c) => c.value === id);
                  return duration
                    ? duration
                    : { value: id, label: `Duration ${id}` }; // fallback label
                })
                .filter(Boolean) || [];

            const selectedLanguages =
              (studyProgram.language_ids || [])
                .map((id) => {
                  const language = languageOpts.find((c) => c.value === id);
                  return language
                    ? language
                    : { value: id, label: `Language ${id}` }; // fallback label
                })
                .filter(Boolean) || [];

            const selectedSubjects =
              (studyProgram.subject_ids || [])
                .map((id) => {
                  const subject = subjectOpts.find((c) => c.value === id);
                  return subject
                    ? subject
                    : { value: id, label: `Subject ${id}` }; // fallback label
                })
                .filter(Boolean) || [];

            setFormData({
              course_name: studyProgram.course_name || "",
              start_of_study: studyProgram.start_of_study || "",
              application_winter_period: studyProgram.application_winter_period || "",
              application_winter_deadline: studyProgram.application_winter_deadline || "",
              application_summer_period: studyProgram.application_summer_period || "",
              application_summer_deadline: studyProgram.application_summer_deadline || "",
              semester_contribution: studyProgram.semester_contribution || "",
              course_credit: studyProgram.course_credit || "",
              admission_requirement: studyProgram.admission_requirement || "",
              admission_restricted:
                statusOptions.find(
                  (opt) => opt.value === studyProgram.admission_restricted
                ) || null,
              career_prospect: studyProgram.career_prospect || "",
              curriculum_structure: studyProgram.curriculum_structure || "",
              course_link: studyProgram.course_link || "",
              application_portal: studyProgram.application_portal || "",
              fees: studyProgram.fees || "",
              tution_fees_per_semester: studyProgram.tution_fees_per_semester || "",
              degree_id: studyProgram.degree_id
                ? degreeOpts.find((opt) => opt.value === studyProgram.degree_id)
                : null,
              coursetype_id: studyProgram.coursetype_id
                ? courseTypeOpts.find((opt) => opt.value === studyProgram.coursetype_id)
                : null,
              university_id: studyProgram.university_id
                ? universityOpts.find(
                  (opt) => opt.value === studyProgram.university_id
                )
                : null,
              application_id: studyProgram.application_id
                ? applicationOpts.find(
                  (opt) => opt.value === studyProgram.application_id
                )
                : null,
              subject_ids: selectedSubjects,
              language_ids: selectedLanguages,
              duration_ids: selectedDurations,
              country_ids: selectedCountries,
            });
            setExistingImage(studyProgram.course_image || "");
          } else {
            console.error("Failed to fetch study program by ID");
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchData();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      const fd = new FormData();
      if (courseImage) fd.append("course_image", courseImage);

      // append normal fields
      const submitData = {
        ...formData,
        start_of_study: cleanEditorContent(formData.start_of_study),
        admission_requirement: cleanEditorContent(formData.admission_requirement),
        career_prospect: cleanEditorContent(formData.career_prospect),
        curriculum_structure: cleanEditorContent(formData.curriculum_structure),
        course_link: cleanEditorContent(formData.course_link),
        application_portal: cleanEditorContent(formData.application_portal),
        fees: formData.semester_contribution,
        degree_id: formData.degree_id?.value || null,
        coursetype_id: formData.coursetype_id?.value || null,
        university_id: formData.university_id?.value || null,
        application_id: formData.application_id?.value || null,
        duration_ids: formData.duration_ids?.map((d) => d.value) || [],
        language_ids: formData.language_ids?.map((l) => l.value) || [],
        subject_ids: formData.subject_ids?.map((s) => s.value) || [],
        country_ids: formData.country_ids?.map((c) => c.value) || [],
      };

      // append normal fields
      Object.entries(submitData).forEach(([key, value]) => {
        if (key === "admission_restricted") {
          fd.append(key, value?.value || "");
        } else if (Array.isArray(value)) {
          // ✅ For arrays (like country_ids)
          fd.append(key, JSON.stringify(value));
        } else if (typeof value === "object" && value !== null) {
          fd.append(key, JSON.stringify(value)); // fallback for any future object
        } else {
          // ✅ For simple strings, booleans, etc.
          fd.append(key, value);
        }
      });

      if (id) {
        const response = await updateStudyProgram(id, fd);
        if (response.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text:
              response.data?.message ||
              "Study program details updated successfully!",
          });
          navigate("/study-program", {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
              showTrash: location.state?.showTrash || false,
              trashPage: location.state?.trashPage || 1,
              trashSearchTerm: location.state?.trashSearchTerm || "",
            },
          });
        } else {
          console.error(
            "Error updating study program:",
            response?.data?.message || "Unknown error"
          );
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response?.data?.message || "Failed to update study program",
          });
        }
      } else {
        const response = await addStudyProgram(fd);
        if (response.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text:
              response.data?.message ||
              "Study program details added successfully",
          });
          navigate("/study-program", {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
              showTrash: location.state?.showTrash || false,
              trashPage: location.state?.trashPage || 1,
              trashSearchTerm: location.state?.trashSearchTerm || "",
            },
          });
        } else {
          console.error(
            "Error updating study program:",
            response.data?.message || "Unknown error"
          );
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data?.message || "Failed to add study program",
          });
        }
      }
    } catch (err) {
      console.error(
        "Error while adding or updating study program:",
        err || "Unknown error"
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err || "Failed to adding or updating study program",
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu={isViewMode ? "View Study Program" : id ? "Edit Study Program" : "Add Study Program"}
        motherMenu="Study Program"
        activeMenuLink={isViewMode ? `view-study-program/${id}` : id ? `edit-study-program/${id}` : "add-study-program"}
        motherMenuLink={"study-program"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div
                      onClick={() => {
                        navigate("/study-program", {
                          state: {
                            page: location.state?.page || 1,
                            searchTerm: location.state?.searchTerm || "",
                            showTrash: location.state?.showTrash || false,
                            trashPage: location.state?.trashPage || 1,
                            trashSearchTerm: location.state?.trashSearchTerm || "",
                          },
                        });
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>{location.state?.showTrash ? "Recycle Bin" : "Study Program List"}</div>
                    </div>
                    <div className="mb-3">
                      <label
                        className="form-label"
                        htmlFor="study-program-image"
                      >
                        Study Program Image
                      </label>
                      <div>
                        <img
                          id="study-program-image"
                          src={
                            courseImage
                              ? URL.createObjectURL(courseImage)
                              : existingImage || NoImage
                          }
                          alt="Study Program Image"
                          width={100}
                          height={100}
                          className="rounded border mb-2"
                        />
                      </div>
                      {!isViewMode && (
                        <div className="change-btn d-flex align-items-center flex-wrap">
                          <input
                            type="file"
                            onChange={handleFileChange}
                            id="imageUpload"
                            className="d-none"
                          />
                          <label
                            htmlFor="imageUpload"
                            className="btn btn-primary ms-0"
                          >
                            Select Image
                          </label>
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="course_name">
                        Course Name
                      </label>
                      <input
                        id="course_name"
                        type="text"
                        name="course_name"
                        className={`form-control ${errors.course_name ? "is-invalid" : ""}`}
                        value={formData.course_name}
                        onChange={handleChange}
                        placeholder="Enter course name"
                        disabled={isViewMode}
                      />
                      {errors.course_name && (
                        <div
                          className="text-danger mt-1"
                          id="course_name-error"
                        >
                          {errors.course_name}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="start_of_study">
                        Start of Study
                      </label>
                      {isViewMode ? (
                        <div className="form-control ck-content" style={{ height: "auto", minHeight: "60px", background: "#f5f5f5", pointerEvents: "none" }} dangerouslySetInnerHTML={{ __html: formData.start_of_study || "" }} />
                      ) : (
                        <CKEditor
                          editor={CustomClassicEditor}
                          data={(formData.start_of_study || "").replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>')}
                          onChange={(event, editor) => {
                            setFormData({ ...formData, start_of_study: editor.getData() });
                          }}
                        />
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Application Winter Period
                      </label>
                      <textarea
                        placeholder="Enter Application Winter Period"
                        className={`form-control me-2`}
                        rows={2}
                        disabled={isViewMode}
                        value={formData.application_winter_period}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            application_winter_period: e.target.value,
                          });
                        }}
                      ></textarea>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Application Summer Period
                      </label>
                      <textarea
                        placeholder="Enter Application Winter Period"
                        className={`form-control me-2`}
                        rows={2}
                        disabled={isViewMode}
                        value={formData.application_summer_period}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            application_summer_period: e.target.value,
                          });
                        }}
                      ></textarea>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Application Winter Deadline
                      </label>
                      <textarea
                        placeholder="Enter Application Winter Period"
                        className={`form-control me-2`}
                        rows={2}
                        disabled={isViewMode}
                        value={formData.application_winter_deadline}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            application_winter_deadline: e.target.value,
                          });
                        }}
                      ></textarea>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Application Summer Deadline
                      </label>
                      <textarea
                        placeholder="Enter Application Winter Period"
                        className={`form-control me-2`}
                        rows={2}
                        disabled={isViewMode}
                        value={formData.application_summer_deadline}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            application_summer_deadline: e.target.value,
                          });
                        }}
                      ></textarea>
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label"
                        htmlFor="semester_contribution"
                      >
                        Semester Contribution
                      </label>
                      <input
                        id="semester_contribution"
                        type="text"
                        name="semester_contribution"
                        className={`form-control`}
                        value={formData.semester_contribution}
                        onChange={handleChange}
                        placeholder="Enter semester contribution"
                        disabled={isViewMode}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="course_credit">
                        Course Credit
                      </label>
                      <input
                        id="course_credit"
                        type="text"
                        name="course_credit"
                        className={`form-control`}
                        value={formData.course_credit}
                        onChange={handleChange}
                        placeholder="Enter course credit"
                        disabled={isViewMode}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Admission Retricted</label>
                      <Select
                        value={formData.admission_restricted}
                        onChange={(value) =>
                          handleSelectChange("admission_restricted", value)
                        }
                        options={statusOptions}
                        placeholder="Select admission restricted"
                        closeMenuOnSelect={true}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        isDisabled={isViewMode}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Admission Requirement
                      </label>
                      {isViewMode ? (
                        <div className="form-control ck-content" style={{ height: "auto", minHeight: "60px", background: "#f5f5f5", pointerEvents: "none" }} dangerouslySetInnerHTML={{ __html: formData.admission_requirement || "" }} />
                      ) : (
                        <CKEditor
                          editor={CustomClassicEditor}
                          data={(formData.admission_requirement).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                          onChange={(event, editor) => {
                            setFormData({ ...formData, admission_requirement: editor.getData() });
                          }}
                        />
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Career Prospect</label>
                      {isViewMode ? (
                        <div className="form-control ck-content" style={{ height: "auto", minHeight: "60px", background: "#f5f5f5", pointerEvents: "none" }} dangerouslySetInnerHTML={{ __html: formData.career_prospect || "" }} />
                      ) : (
                        <CKEditor
                          editor={CustomClassicEditor}
                          data={(formData.career_prospect).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                          onChange={(event, editor) => {
                            setFormData({ ...formData, career_prospect: editor.getData() });
                          }}
                        />
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Curriculum Structure</label>
                      {isViewMode ? (
                        <div className="form-control ck-content" style={{ height: "auto", minHeight: "60px", background: "#f5f5f5", pointerEvents: "none" }} dangerouslySetInnerHTML={{ __html: formData.curriculum_structure || "" }} />
                      ) : (
                        <CKEditor
                          editor={CustomClassicEditor}
                          data={(formData.curriculum_structure).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                          onChange={(event, editor) => {
                            setFormData({ ...formData, curriculum_structure: editor.getData() });
                          }}
                        />
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Course Links</label>
                      {isViewMode ? (
                        <div className="form-control ck-content" style={{ height: "auto", minHeight: "60px", background: "#f5f5f5", pointerEvents: "none" }} dangerouslySetInnerHTML={{ __html: formData.course_link || "" }} />
                      ) : (
                        <CKEditor
                          editor={CustomClassicEditor}
                          data={(formData.course_link).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                          onChange={(event, editor) => {
                            setFormData({ ...formData, course_link: editor.getData() });
                          }}
                        />
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Application Portal</label>
                      {isViewMode ? (
                        <div className="form-control ck-content" style={{ height: "auto", minHeight: "60px", background: "#f5f5f5", pointerEvents: "none" }} dangerouslySetInnerHTML={{ __html: formData.application_portal || "" }} />
                      ) : (
                        <CKEditor
                          editor={CustomClassicEditor}
                          data={(formData.application_portal).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                          onChange={(event, editor) => {
                            setFormData({ ...formData, application_portal: editor.getData() });
                          }}
                        />
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="degree">
                        Degree
                      </label>
                      <Select
                        id="degree"
                        value={formData.degree_id}
                        onChange={(value) =>
                          handleSelectChange("degree_id", value)
                        }
                        options={degreeOptions}
                        placeholder="Select degree"
                        closeMenuOnSelect={true}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        isLoading={degreeLoading}
                        isDisabled={isViewMode}
                      />
                      {errors.degree_id && (
                        <div className="text-danger mt-1" id="degree-error">
                          {errors.degree_id}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="coursetype">
                        Course Type
                      </label>
                      <Select
                        id="coursetype"
                        value={formData.coursetype_id}
                        onChange={(value) =>
                          handleSelectChange("coursetype_id", value)
                        }
                        options={courseTypeOptions}
                        placeholder="Select course type"
                        closeMenuOnSelect={true}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        isLoading={courseTypeLoading}
                        isDisabled={isViewMode}
                      />
                      {errors.coursetype_id && (
                        <div className="text-danger mt-1" id="coursetype-error">
                          {errors.coursetype_id}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="university">
                        University
                      </label>
                      <Select
                        id="university"
                        value={formData.university_id}
                        onChange={(value) =>
                          handleSelectChange("university_id", value)
                        }
                        options={universityOptions}
                        placeholder="Select university"
                        closeMenuOnSelect={true}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        isLoading={universityLoading}
                        isDisabled={isViewMode}
                      />
                      {errors.university_id && (
                        <div className="text-danger mt-1" id="university-error">
                          {errors.university_id}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="application">
                        Application
                      </label>
                      <Select
                        id="application"
                        value={formData.application_id}
                        onChange={(value) =>
                          handleSelectChange("application_id", value)
                        }
                        options={applicationOptions}
                        placeholder="Select application"
                        closeMenuOnSelect={true}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        isLoading={applicationLoading}
                        isDisabled={isViewMode}
                      />
                      {errors.application_id && (
                        <div
                          className="text-danger mt-1"
                          id="application-error"
                        >
                          {errors.application_id}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="subject">
                        Subject
                      </label>
                      <Select
                        id="subject"
                        isMulti
                        value={formData.subject_ids}
                        onChange={handleSubjectChange}
                        options={subjectOptions}
                        placeholder={
                          subjectLoading
                            ? "Loading subjects..."
                            : "Select subject"
                        }
                        isLoading={subjectLoading}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isClearable={false}
                        isSearchable={false}
                        components={multiSelectComponents}
                        isDisabled={isViewMode}
                      />
                      {errors.subject_ids && (
                        <div className="text-danger mt-1" id="subject-error">
                          {errors.subject_ids}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="language">
                        Language
                      </label>
                      <Select
                        id="language"
                        isMulti
                        value={formData.language_ids}
                        onChange={handleLanguageChange}
                        options={languageOptions}
                        placeholder={
                          languageLoading
                            ? "Loading languages..."
                            : "Select language"
                        }
                        isLoading={languageLoading}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isClearable={false}
                        isSearchable={false}
                        components={multiSelectComponents}
                        isDisabled={isViewMode}
                      />
                      {errors.language_ids && (
                        <div className="text-danger mt-1" id="language-error">
                          {errors.language_ids}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="duration">
                        Duration
                      </label>
                      <Select
                        id="duration"
                        isMulti
                        value={formData.duration_ids}
                        onChange={handleDurationChange}
                        options={durationOptions}
                        placeholder={
                          durationLoading
                            ? "Loading durations..."
                            : "Select duration"
                        }
                        isLoading={durationLoading}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isClearable={false}
                        isSearchable={false}
                        components={multiSelectComponents}
                        isDisabled={isViewMode}
                      />
                      {errors.duration_ids && (
                        <div className="text-danger mt-1" id="duration-error">
                          {errors.duration_ids}
                        </div>
                      )}
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-12 mb-md-0 mb-3">
                        <label className="form-label" htmlFor="tution_fees_per_semester">
                          Tution Fees per semester
                        </label>
                        <input
                          type="text"
                          name="tution_fees_per_semester"
                          className={`form-control ${errors.tution_fees_per_semester ? "is-invalid" : ""}`}
                          value={formData.tution_fees_per_semester}
                          onChange={handleChange}
                          placeholder="Enter tution fees per semester"
                          disabled={isViewMode}
                        />
                        {errors.tution_fees_per_semester && (
                          <div className="invalid-feedback" id="tution_fees_per_semester-errors">
                            {errors.tution_fees_per_semester}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label" htmlFor="country">
                        Country
                      </label>
                      <Select
                        id="country"
                        isMulti
                        value={formData.country_ids}
                        onChange={handleCountryChange}
                        options={countryOptions}
                        placeholder={
                          countryLoading
                            ? "Loading countries..."
                            : "Select country"
                        }
                        isLoading={countryLoading}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isClearable={false}
                        isSearchable={false}
                        components={multiSelectComponents}
                        isDisabled={isViewMode}
                      />
                      {errors.country_ids && (
                        <div className="text-danger mt-1" id="country-error">
                          {errors.country_ids}
                        </div>
                      )}
                    </div>

                    <hr style={{ margin: "0px" }} className="mx-2" />
                    <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                      <Button
                        id="cancel-button"
                        type="button"
                        variant="secondary"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => {
                          navigate("/study-program", {
                            state: {
                              page: location.state?.page || 1,
                              searchTerm: location.state?.searchTerm || "",
                              showTrash: location.state?.showTrash || false,
                              trashPage: location.state?.trashPage || 1,
                              trashSearchTerm: location.state?.trashSearchTerm || "",
                            },
                          });
                        }}
                      >
                        Back
                      </Button>

                      {!isViewMode && (
                        <Button
                          id="save-button"
                          type="submit"
                          className="btn btn-primary btn-sm"
                        >
                          {id ? "Update" : "Save"}
                        </Button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div >
    </>
  );
};

export default AddStudyProgram;
